<button class="button" v-bind="$attrs" @click="isOpen = true">
	<slot/>
</button>

<newsletter-modal v-model="isOpen"/>
